let currentNum = 1;

export default function () {
  return 'abc' + ++currentNum
}